import { reactive } from 'vue';

export const criarUsuario = () => {
    return reactive({
        id: 0,
        idep: 0,
        idperfil: 0,
        idestabelecimento: 0,
        cdusuario: 0,
        nmusuario: '',
        cpf: '',
        cpfnros: '',
        endereco: '',
        nmendereco: 0,
        complemento: '',
        bairro: '',
        cep: '',
        nmmunicipio: '',
        uf: '',
        fone: '',
        celular: '',
        email: '',
        email2: '',
        registro_orgao: '',
        registro_numero: 0,
        matricula_numero: 0,
        formacao_academica: '',
        login: '',
        senha: '',
        dtsenha: '',
        ativo: 'S',
        nivel: 1,
        perfil_estabelecimento: 'N',
        perfil_gestor: 'N',
        perfil_inspetor: 'N',
        perfil_rt: 'N',
        perfil_supervisor: 'N',
        idusuario: 0,
        idlogin: 0
    });
};